export interface IPendChangesAgg {

    TotalRows: number
    TotalChanges: number
    OldestChange: Date
    NewestChange: Date
    PendingChangeList: PendChangesAggListESP[]
}

export class PendChangesAgg implements IPendChangesAgg {

    TotalRows: number = 0;
    TotalChanges: number = 0;
    OldestChange: Date = new Date(0);
    NewestChange: Date = new Date(0);
    PendingChangeList: PendChangesAggListESP[] = [];

    constructor(src?: IPendChangesAgg) {
        if (src) {
            this.TotalRows = src.TotalRows;
            this.TotalChanges = src.TotalChanges;
            this.OldestChange = src.OldestChange;
            this.NewestChange = src.NewestChange;
            this.PendingChangeList = src.PendingChangeList;
        }
    }

}

export interface IPendChangesAggListESP {

    SalesEntityID: number
    Breadcrumbs:string;
    Name: string
    FromDTM: Date
    ToDTM: Date
    ChangeCount: number
}

export class PendChangesAggListESP implements IPendChangesAggListESP {

    SalesEntityID: number = 0;
    Breadcrumbs:string = "";
    ChangeCount: number = 0;
    FromDTM: Date = new Date(0);
    ToDTM: Date = new Date(0);
    Name: string = '';

    constructor(src?: IPendChangesAggListESP) {
        if (src) {
            this.Name = src.Name;
            this.Breadcrumbs = src.Breadcrumbs;
            this.ToDTM = src.ToDTM;
            this.FromDTM = src.FromDTM;
            this.ChangeCount = src.ChangeCount;
            this.SalesEntityID = src.SalesEntityID;
        }


    }

}



export interface IPendChangeListESP {

    ChangeID: number
    RootObjectID: number
    SecurableID: number
    SecurableName: string
    OldValue: string
    NewValue: string
    ProposedByUserID: number
    ProposedByUserName: string
    ProposedDTM: Date
    CurrentApprovalLevel: boolean
    RequiredApprovalLevel: boolean
    UserApprovalLevel: number
    Selected: boolean
}

export class PendChangeListESP implements IPendChangeListESP {

    ChangeID: number = 0;
    RootObjectID: number = 0;
    SecurableID: number = 0;
    SecurableName: string = '';
    OldValue: string = '';
    NewValue: string = '';
    ProposedByUserID: number = 0;
    ProposedByUserName: string = '';
    ProposedDTM: Date = new Date(0);
    CurrentApprovalLevel: boolean = false;
    RequiredApprovalLevel: boolean = false;
    Selected: boolean = false;
    UserApprovalLevel: number = 0;

    constructor(src?: IPendChangeListESP) {
        if (src) {
            this.ChangeID = src.ChangeID;
            this.RootObjectID = src.RootObjectID;
            this.SecurableID = src.SecurableID;
            this.SecurableName = src.SecurableName;
            this.OldValue = src.OldValue;
            this.NewValue = src.NewValue;
            this.ProposedByUserID = src.ProposedByUserID;
            this.ProposedByUserName = src.ProposedByUserName;
            this.ProposedDTM = src.ProposedDTM;
            this.CurrentApprovalLevel = src.CurrentApprovalLevel;
            this.RequiredApprovalLevel = src.RequiredApprovalLevel;
            this.UserApprovalLevel = src.UserApprovalLevel;
        }


    }

}


export interface IChangesListInq {
    SalesEntityID?: number;
    IncludePending: boolean;
    IncludeApproved: boolean;
    IncludeDeclined: boolean;
    ActionFromDTM?: Date;
    ActionToDTM?: Date;
    Search: string;
    StartPage: number;
    MaxRows: number;
    ShowUnactionable: boolean;
}

export class ChangesListInq implements IChangesListInq {

    SalesEntityID: number = null;
    IncludePending: boolean = false;
    IncludeApproved: boolean = false;
    IncludeDeclined: boolean = false;
    ActionFromDTM: Date = null;
    ActionToDTM: Date = null;
    Search: string = "";
    StartPage: number = 1;
    MaxRows: number = 5;
    ShowUnactionable: boolean = false;

    constructor(src?: IChangesListInq) {
        if (src) {
            this.SalesEntityID = src.SalesEntityID;
            this.IncludePending = src.IncludePending;
            this.IncludeApproved = src.IncludeApproved;
            this.IncludeDeclined = src.IncludeDeclined;
            this.ActionFromDTM = src.ActionFromDTM;
            this.ActionToDTM = src.ActionToDTM;
            this.Search = src.Search;
            this.MaxRows = src.MaxRows;
            this.ShowUnactionable = src.ShowUnactionable;
        }
    }
}



export interface IChangesListResult {
    TotalRows: number;
    ChangeListESP: ChangeListESP[];
}

export class ChangesListResult implements IChangesListResult {

    TotalRows: number = 0;
    ChangeListESP: ChangeListESP[] = [];

    constructor(src?: IChangesListResult) {
        if (src) {
            this.TotalRows = src.TotalRows;
            this.ChangeListESP = src.ChangeListESP;
        }
    }
}


export interface IChangeListESP {
    ChangeID: number;
    Breadcrumbs:string;
    SalesEntityID: number;
    SalesEntityName: string;
    SecurableID: number;
    SecurableName: string;
    OldValue: string;
    NewValue: string;
    ProposedByUserID: number;
    ProposedByUserName: string;
    ProposedDTM: Date;
    LastActionDTM?: Date;
    ApprovalStatus: string;
    CurrentApprovalLevel: number;
    RequiredApprovalLevel: number;
    UserApprovalLevel: number;
    ChangeAction: string;
    ChangeSetID?: number;
    IsActionable: boolean;
    Selected: boolean;
    ApprovalStatusDetail: string;
    FriendlyName: string;
    ObjectDescription: string;
}

export class ChangeListESP implements IChangeListESP {

    ChangeID: number = 0;
    Breadcrumbs:string = "";
    SalesEntityID: number = 0;
    SalesEntityName: string = "";
    SecurableID: number = 0;
    SecurableName: string = "";
    OldValue: string = "";
    NewValue: string = "";
    ProposedByUserID: number = 0;
    ProposedByUserName: string = "";
    ProposedDTM: Date = new Date(0);
    LastActionDTM: Date = null;
    ApprovalStatus: string = "";
    CurrentApprovalLevel: number = 0;
    RequiredApprovalLevel: number = 0;
    UserApprovalLevel: number = 0;
    ChangeAction: string = "";
    ChangeSetID: number = 0;
    IsActionable: boolean = false;
    Selected: boolean = false;
    ApprovalStatusDetail: string = "";
    FriendlyName: string = "";
    ObjectDescription: string = "";

    constructor(src?: IChangeListESP) {
        if (src) {
            this.ChangeID = src.ChangeID;
            this.Breadcrumbs = src.Breadcrumbs;
            this.SalesEntityID = src.SalesEntityID;
            this.SalesEntityName = src.SalesEntityName;
            this.SecurableName = src.SecurableName;
            this.SecurableID = src.SecurableID;
            this.OldValue = src.OldValue;
            this.NewValue = src.NewValue;
            this.ProposedByUserID = src.ProposedByUserID;
            this.ProposedByUserName = src.ProposedByUserName;
            this.ProposedDTM = src.ProposedDTM;
            this.LastActionDTM = src.LastActionDTM;
            this.ApprovalStatus = src.ApprovalStatus;
            this.CurrentApprovalLevel = src.CurrentApprovalLevel;
            this.RequiredApprovalLevel = src.RequiredApprovalLevel;
            this.RequiredApprovalLevel = src.RequiredApprovalLevel;
            this.UserApprovalLevel = src.UserApprovalLevel;
            this.ChangeAction = src.ChangeAction;
            this.ChangeSetID = src.ChangeSetID;
            this.IsActionable = src.IsActionable;
            this.Selected = src.Selected && src.IsActionable;
            this.FriendlyName = src.FriendlyName;
            this.ObjectDescription = src.ObjectDescription;
        }
    }
}




export interface IListInq {
    Search: string;
    StartPage: number;
    MaxRows: number;
    ShowUnactionable: boolean;
    ProposedFromDTM?: Date;
    ProposedToDTM?: Date;
}

export class ListInq implements IListInq {

    Search: string = "";
    StartPage: number = 0;
    MaxRows: number = 0;
    ShowUnactionable: boolean = false;
    ProposedFromDTM: Date = null;
    ProposedToDTM: Date = null;

    constructor(src?: IListInq) {
        if (src) {
            this.Search = src.Search;
            this.StartPage = src.StartPage;
            this.MaxRows = src.MaxRows;
            this.ShowUnactionable = src.ShowUnactionable;
            this.ProposedFromDTM = src.ProposedFromDTM;
            this.ProposedToDTM = src.ProposedToDTM;
        }
    }
}

export interface IChangeDetailList {
    ApprovalLevel: number;
    ApprovalBy: number;
    ApprovalByUserName: string;
    ApprovalDTM: string;
    ApprovalAction: string;
    Note: string;
}

export class ChangeDetailList implements IChangeDetailList {

    ApprovalLevel: number = 0;
    ApprovalBy: number = 0;
    ApprovalByUserName: string = "";
    ApprovalDTM: string = "";
    ApprovalAction: string = "";
    Note: string = "";

    constructor(src?: IChangeDetailList) {
        if (src) {
            this.ApprovalLevel = src.ApprovalLevel;
            this.ApprovalBy = src.ApprovalBy;
            this.ApprovalByUserName = src.ApprovalByUserName;
            this.ApprovalDTM = src.ApprovalDTM;
            this.ApprovalAction = src.ApprovalAction;
            this.Note = src.Note;
        }
    }
}


export interface IChgApproval {

    ChangeID: number;
    ApprovalAction: string;
    Note: string;

}

export class ChgApproval implements IChgApproval {

    ChangeID: number = 0;
    ApprovalAction: string = "";
    Note: string = "";

    constructor(src?: IChgApproval) {
        if (src) {
            this.ChangeID = src.ChangeID;
            this.ApprovalAction = src.ApprovalAction;
            this.Note = src.Note;
        }
    }
}
